/**
 * Shared audio availability cache.
 * Used by AudioPlayer and CompactAudioPlayer to avoid
 * redundant HEAD requests for the same recording URL.
 */
export const audioAvailabilityCache = new Map();

export const clearAudioCache = () => audioAvailabilityCache.clear();
